import { Box, styled } from '@mui/material';

export const PageContainer = styled(Box)({
	boxSizing: 'border-box',
	display: 'flex',
	height: '100vh',
	padding: '12px 18px',
});
